/**
 * @generated SignedSource<<a3560bb46488b77bc6f3236190e1229c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateSkillCategoryInput = {
  name?: string | null;
  assignedSkills?: ReadonlyArray<string | null> | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type createSkillCategoryMutation$variables = {
  input: CreateSkillCategoryInput;
};
export type createSkillCategoryMutation$data = {
  readonly createSkillCategory: {
    readonly skillCategory: {
      readonly node: {
        readonly id: string;
        readonly name: string | null;
      } | null;
    } | null;
  } | null;
};
export type createSkillCategoryMutation = {
  variables: createSkillCategoryMutation$variables;
  response: createSkillCategoryMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateSkillCategoryPayload",
    "kind": "LinkedField",
    "name": "createSkillCategory",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SkillCategoryTypeEdge",
        "kind": "LinkedField",
        "name": "skillCategory",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SkillCategory",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createSkillCategoryMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createSkillCategoryMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5346fd4c825a2f3066bb53ca1b2eb622",
    "id": null,
    "metadata": {},
    "name": "createSkillCategoryMutation",
    "operationKind": "mutation",
    "text": "mutation createSkillCategoryMutation(\n  $input: CreateSkillCategoryInput!\n) {\n  createSkillCategory(input: $input) {\n    skillCategory {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "01b8438a9acf3b46494634d1f411b794";

export default node;
